import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-vendors-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './vendors-page.component.html',
  styleUrl: './vendors-page.component.css'
})
export class VendorsPageComponent {

}
